import { render, staticRenderFns } from "./FixedBearingsFormEffects.vue?vue&type=template&id=080c2440&scoped=true"
import script from "./FixedBearingsFormEffects.vue?vue&type=script&lang=js"
export * from "./FixedBearingsFormEffects.vue?vue&type=script&lang=js"
import style0 from "./FixedBearingsFormEffects.vue?vue&type=style&index=0&id=080c2440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c2440",
  null
  
)

export default component.exports